import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import stateCityData from "../../../data/states.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCity,
  faEnvelope,
  faMapMarkerAlt,
  faPhoneAlt,
  faUser,
  faNewspaper,
  faVenusMars,
  faIdCard,
  faTint,
  faEye,
  faEyeSlash,
  faUserPlus,
  faArrowRight,
  faArrowLeft,
  faCheckCircle,
  faCalendar,
  faMicrophone,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";

const PressRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Set default role to Press Conference
  const [selectedRole, setSelectedRole] = useState("Press Conference");

  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    email: "",
    mobile: "",
    aadharNo: "",
    pancard: "",
    dateOfBirth: "",
    bloodType: "",
    residenceaddress: "",
    state: "",
    city: "",
    pincode: "",
    password: "",
    confirmpassword: "",
  });

  const [states] = useState(Object.keys(stateCityData));
  const [cities, setCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOtpFields, setShowOtpFields] = useState(false);
  const [timer, setTimer] = useState(120);
  // Add timer countdown using setTimeout
  React.useEffect(() => {
    if (!showOtpFields) return;
    if (timer > 0) {
      const timeout = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearTimeout(timeout);
    } else if (timer === 0) {
      // Enable resend button when timer reaches 0
      setCanResendOTP(true);
    }
  }, [timer, showOtpFields]);
  const [isResending, setIsResending] = useState(false);
  const [canResendOTP, setCanResendOTP] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [otpData, setOtpData] = useState({
    otpEmail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // For mobile field: allow only digits and max 10 digits
    if (name === "mobile") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setFormData({
        ...formData,
        [name]: digitsOnly,
      });
    } else if (name === "aadharNo") {
      // Only allow digits, max 12
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      setFormData({
        ...formData,
        [name]: digitsOnly,
      });
    } else if (name === "name") {
      // Only allow letters and spaces
      const lettersOnly = value.replace(/[^A-Za-z\s]/g, "");
      setFormData({
        ...formData,
        [name]: lettersOnly,
      });
    } else if (name === "pancard") {
      // Only allow up to 10 chars, first 5 digits, last 5 uppercase letters
      let pancardValue = value.toUpperCase().replace(/[^0-9A-Z]/g, "");
      pancardValue = pancardValue.slice(0, 10);
      setFormData({
        ...formData,
        [name]: pancardValue,
      });
    } else if (name === "pincode") {
      // Only allow digits, max 6
      const digitsOnly = value.replace(/\D/g, "").slice(0, 6);
      setFormData({
        ...formData,
        [name]: digitsOnly,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    setFormError("");
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setFormData({
      ...formData,
      state: selectedState,
      city: "",
    });

    // Get cities for selected state from the imported data
    if (selectedState) {
      setCities(stateCityData[selectedState] || []);
    } else {
      setCities([]);
    }
  };


  const validateForm = () => {
    // Check all input field validations first
    // Check if required fields are filled
    // List of required fields and their labels
    const requiredFields = [
      { key: 'name', label: 'Full Name' },
      { key: 'gender', label: 'Gender' },
      { key: 'email', label: 'Email' },
      { key: 'mobile', label: 'Mobile Number' },
      { key: 'aadharNo', label: 'Aadhar Number' },
      { key: 'dateOfBirth', label: 'Date of Birth' },
      { key: 'pancard', label: 'PAN Card' },
      { key: 'residenceaddress', label: 'Residence Address' },
      { key: 'bloodType', label: 'Blood Type' },
      { key: 'state', label: 'State' },
      { key: 'city', label: 'City' },
      { key: 'pincode', label: 'PinCode' },
      { key: 'password', label: 'Password' },
      { key: 'confirmpassword', label: 'Confirm Password' },
      { key: 'termsAccepted', label: 'Terms and Conditions' },
    ];
    const missingFields = requiredFields.filter(f => !formData[f.key]);
    if (missingFields.length > 0) {
      const missingLabels = missingFields.map(f => f.label).join(', ');
      const errorMsg = `Please fill the following field${missingFields.length > 1 ? 's' : ''}: ${missingLabels}`;
      setFormError(errorMsg);
      if (typeof toast === 'function') {
        toast.error(errorMsg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Validate name (must contain only letters and spaces, no numbers)
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name)) {
      const msg = "Name must contain only letters and spaces (no numbers allowed)";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Check if email is missing
    if (!formData.email) {
      const msg = "Email is required.";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      const msg = "Please enter a valid email address";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Only allow emails ending with @gmail.com
    if (!formData.email.endsWith('@gmail.com')) {
      const msg = "Only @gmail.com email addresses are allowed";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Validate mobile number (must be exactly 10 digits, no alphabets or extra digits)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      let msg = "";
      if (formData.mobile.length < 10) {
        msg = "Mobile number must be exactly 10 digits.";
      } else {
        msg = `Mobile number must be exactly 10 digits and contain only numbers. You entered ${formData.mobile.replace(/\D/g, "").length
          } digits.`;
      }
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Validate Aadhar number (must be filled, exactly 12 digits, only numbers, no alphabets, not more or less)
    if (!formData.aadharNo) {
      const msg = "Aadhar number is required.";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const aadharRegex = /^\d{12}$/;
    if (!aadharRegex.test(formData.aadharNo)) {
      let msg = "";
      if (formData.aadharNo.length !== 12) {
        msg = "Aadhar number must be exactly 12 digits.";
      } else {
        msg = "Aadhar number must be exactly 12 digits and contain only numbers (no alphabets or extra digits).";
      }
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }


    // PAN card: must be 10 characters, with exactly 4 digits and 6 uppercase letters in any order
    const pancardRegex = /^[A-Z0-9]{10}$/;
    if (!formData.pancard) {
      const msg = "PAN card number is required";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    if (formData.pancard.length !== 10) {
      const msg = "PAN card number must be exactly 10 characters (4 digits and 6 uppercase letters, any order)";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    if (!pancardRegex.test(formData.pancard)) {
      const msg = "PAN card number must contain only uppercase letters and digits";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Check for exactly 4 digits and 6 uppercase letters
    const digitCount = (formData.pancard.match(/\d/g) || []).length;
    const letterCount = (formData.pancard.match(/[A-Z]/g) || []).length;
    if (digitCount !== 4 || letterCount !== 6) {
      const msg = "PAN card number must have exactly 4 digits and 6 uppercase letters (any order)";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Validate date of birth (must be filled, in the past, and above 13 years)
    if (!formData.dateOfBirth) {
      const msg = "Date of birth is required.";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const today = new Date();
    const dob = new Date(formData.dateOfBirth);
    if (dob >= today) {
      const msg = "Date of birth must be in the past";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // User must be strictly above 13 years old (not just 13)
    const minAge = 13;
    const yearDiff = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();
    let isAbove13 = false;
    if (yearDiff > minAge) {
      isAbove13 = true;
    } else if (yearDiff === minAge) {
      if (monthDiff > 0) {
        isAbove13 = true;
      } else if (monthDiff === 0 && dayDiff > 0) {
        isAbove13 = true;
      }
    }
    if (!isAbove13) {
      const msg = "You must be above 13 years old to register";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // validate pincode (must be exactly 6 digits)
    const pincodeRegex = /^[0-9]{6}$/;
    if (!pincodeRegex.test(formData.pincode)) {
      let msg = "";
      if (formData.pincode.length < 6) {
        msg = "Pincode must be exactly 6 digits.";
      } else {
        msg = "Pincode must be exactly 6 digits and contain only numbers (no alphabets or extra digits).";
      }
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Validate password (at least 8 characters)
    if (formData.password.length < 8) {
      const msg = "Password must be at least 8 characters long";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // Check if passwords match
    if (formData.password !== formData.confirmpassword) {
      const msg = "Passwords do not match";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    // LAST: check terms and conditions
    if (!formData.termsAccepted) {
      const msg = "You must accept the terms and conditions";
      setFormError(msg);
      if (typeof toast === 'function') {
        toast.error(msg);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError("");

    // Validate form before submission
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      console.log("Sending registration data:", formData); // Debug log

      // Send form data to press conference API
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/press/register`,
        {
          ...formData,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Registration response:", response); // Debug log

      // Always show OTP fields after successful form submission
      // setShowOtpFields(true);

      if (response.status === 400) {
        toast.error("Press Conference user already exists. Please login.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          navigate("/press/login");
        }, 2000);
      }

      if (response.status === 200) {
        toast.success("OTP sent to your email. Please verify within 2 minutes.");
        setShowOtpFields(true);
        setTimer(120); // Reset timer
        setCanResendOTP(false); // Disable resend button initially
      }

      if (!response.data.success) {
        setFormError(
          response.data.message || "Registration failed. Please try again."
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (error) {
      setFormError(
        error.response?.data?.message ||
        "Registration failed. Please try again."
      );
      if (error.response && error.response.status === 400) {
        //Show some error message
        toast.error(
          error.response.data.message ||
          "Registration failed. Please try again."
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOtpChange = (e) => {
    setOtpData({
      ...otpData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOtpSubmit = async (e) => {
    console.log("in otp submit handle");
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/press/verify-otp`,
        {
          email: formData.email,
          mobile: formData.mobile,
          otpEmail: otpData.otpEmail,
        }
      );

      console.log("response after sending otp", response);
      if (response.status === 400) {
        toast.error("Press Conference user not found. Please register first.");
        navigate("/press/register");
      }
      if (response.status === 200) {
        toast.success("Press Conference registration successful! Redirecting to login...");
        setShowOtpFields(false);
        setTimeout(() => {
          navigate("/press/login");
        }, 2000);
      } else {
        setFormError(response.data.message || "OTP verification failed");
      }
    } catch (error) {
      setFormError(error.response?.data?.message || "OTP verification failed");
    }
  };

  const handleResendOTP = async () => {
    setIsResending(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/press/resend/otp`,
        {
          email: formData.email,
          mobile: formData.mobile,
        }
      );

      if (response.data.success) {
        // Reset timer and disable resend button
        setTimer(120);
        setCanResendOTP(false);
        toast.success("OTP resent successfully!");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
    } finally {
      setIsResending(false);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8 pt-20">
      <div className="w-full max-w-6xl mx-auto bg-white rounded-[2rem] shadow-2xl shadow-indigo-200/50 overflow-hidden border border-slate-100 min-h-[700px]">
        <div className="flex flex-col lg:flex-row h-full">
          {/* Left side - Branding Image */}
          <div className="hidden lg:flex lg:w-5/12 bg-gradient-to-br from-indigo-700 via-blue-600 to-indigo-900 p-10 relative overflow-hidden flex-col justify-center items-center">
            {/* Abstract Background Elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -mr-20 -mt-20"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-indigo-400 opacity-20 rounded-full blur-2xl -ml-10 -mb-10"></div>

            <div className="relative z-10 flex flex-col justify-center items-center text-white text-center w-full">
              <div className="w-24 h-24 mx-auto mb-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl flex items-center justify-center shadow-xl transform transition-transform duration-500 hover:scale-105">
                <FontAwesomeIcon icon={faMicrophone} className="text-4xl text-white" />
              </div>

              <h1 className="text-4xl font-[1000] tracking-tight mb-4 drop-shadow-sm uppercase">Press <br /><span className="text-indigo-200 text-2xl font-bold">Conference</span></h1>
              <p className="text-indigo-100 font-bold tracking-wide text-sm opacity-90 max-w-xs mx-auto leading-relaxed mb-8">
                Join exclusive press conferences and media briefings.
              </p>

              <div className="space-y-4 w-full max-w-xs text-left">
                <div className="flex items-center text-sm font-bold text-indigo-50 bg-white/5 p-3 rounded-xl border border-white/10 shadow-sm backdrop-blur-sm">
                  <FontAwesomeIcon icon={faVideo} className="mr-3 w-5 text-indigo-300" />
                  <span>Live streaming access</span>
                </div>
                <div className="flex items-center text-sm font-bold text-indigo-50 bg-white/5 p-3 rounded-xl border border-white/10 shadow-sm backdrop-blur-sm">
                  <FontAwesomeIcon icon={faNewspaper} className="mr-3 w-5 text-indigo-300" />
                  <span>Exclusive media content</span>
                </div>
                <div className="flex items-center text-sm font-bold text-indigo-50 bg-white/5 p-3 rounded-xl border border-white/10 shadow-sm backdrop-blur-sm">
                  <FontAwesomeIcon icon={faCalendar} className="mr-3 w-5 text-indigo-300" />
                  <span>Event notifications</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - Form */}
          <div className="w-full lg:w-7/12 p-6 sm:p-10 lg:p-12 flex flex-col bg-white justify-center h-full">
            <div className="mb-8 text-center lg:text-left animate-fadeIn">
              <h1 className="text-3xl sm:text-4xl font-[1000] text-slate-900 tracking-tight mb-2 uppercase">
                Register
              </h1>
              <div className="w-12 h-1.5 bg-indigo-600 rounded-full mb-3 mx-auto lg:mx-0"></div>
              <p className="text-xs font-bold text-slate-500 tracking-wide uppercase">
                Create Your Account
              </p>
            </div>
            {/* Registration form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              {formError && (
                <div className="bg-red-50 border border-red-200 text-red-700 p-2 rounded-md text-xs font-medium">
                  {formError}
                </div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {/* Name Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Full Name
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faUser}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Full Name"
                      required
                    />
                  </div>
                </div>

                {/* Gender Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Gender
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faVenusMars}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                {/* Email Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Email
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>

                {/* Mobile Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Mobile Number
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faPhoneAlt}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Mobile"
                      required
                    />
                  </div>
                </div>

                {/* Aadhar Card field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Aadhar Number
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faIdCard}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="text"
                      name="aadharNo"
                      value={formData.aadharNo}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Aadhar No."
                      pattern="[0-9]{12}"
                      maxLength="12"
                    />
                  </div>
                </div>

                {/* PAN Card field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    PAN Card
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faIdCard}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="text"
                      name="pancard"
                      value={formData.pancard}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="PAN Card"
                    />
                  </div>
                </div>

                {/* Date of Birth field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Date of Birth
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faCalendar}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                    />
                  </div>
                </div>

                {/* Blood Type field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Blood Type
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faTint}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <select
                      name="bloodType"
                      value={formData.bloodType}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                    >
                      <option value="">Select Blood Type</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                  </div>
                </div>

                {/* State Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    State
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleStateChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                      required
                    >
                      <option value="">Select State</option>
                      {states.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* City Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    City
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faCity}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 appearance-none"
                      required
                      disabled={!formData.state}
                    >
                      <option value="">Select City</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Address Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Residence Address
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="text"
                      name="residenceaddress"
                      value={formData.residenceaddress}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Address"
                    />
                  </div>
                </div>

                {/* PinCode Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    PinCode
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-4 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="PinCode"
                      required
                    />
                  </div>
                </div>

                {/* Password Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Password
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faEye}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-10 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        className="text-slate-400 hover:text-indigo-500 transition-colors cursor-pointer"
                      />
                    </button>
                  </div>
                </div>

                {/* Confirm Password Field */}
                <div>
                  <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1 mb-1">
                    Confirm Password
                  </label>
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                      <FontAwesomeIcon
                        icon={faEye}
                        className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                      />
                    </div>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmpassword"
                      value={formData.confirmpassword}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-10 py-2 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900"
                      placeholder="Confirm Password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <FontAwesomeIcon
                        icon={showConfirmPassword ? faEyeSlash : faEye}
                        className="text-slate-400 hover:text-indigo-500 transition-colors cursor-pointer"
                      />
                    </button>
                  </div>
                </div>
              </div>

              {/* Terms and conditions */}
              <div className="flex items-start mt-6 bg-slate-50 p-4 rounded-xl border-2 border-slate-100">
                <div className="flex items-center h-5">
                  <input
                    id="terms"
                    name="termsAccepted"
                    type="checkbox"
                    checked={!!formData.termsAccepted}
                    onChange={(e) =>
                      setFormData({ ...formData, termsAccepted: e.target.checked })
                    }
                    className="w-4 h-4 text-indigo-600 bg-white border-2 border-slate-300 rounded focus:ring-indigo-500 focus:ring-2 cursor-pointer transition-all"
                  />
                </div>
                <div className="ml-3 text-xs">
                  <label
                    htmlFor="terms"
                    className="font-bold text-slate-600 cursor-pointer"
                  >
                    I accept the{" "}
                    <span
                      className="text-indigo-600 hover:text-indigo-700 underline font-black transition-colors"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/termscondition", "_blank");
                      }}
                    >
                      terms and conditions
                    </span>
                  </label>
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-8">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full flex justify-center py-4 px-4 rounded-xl shadow-lg shadow-indigo-200/50 text-sm font-black text-white bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 active:scale-[0.98] transition-all uppercase tracking-widest ${isSubmitting ? "opacity-70 cursor-wait" : ""
                    }`}
                >
                  {isSubmitting ? (
                    <div className="flex items-center">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      PROCESSING...
                    </div>
                  ) : (
                    "CREATE ACCOUNT"
                  )}
                </button>
              </div>

              <div className="text-center mt-6">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                  Already have an account?
                </span>
                <Link
                  to="/press/login"
                  className="inline-flex items-center text-indigo-600 font-black ml-2 hover:text-indigo-700 transition-colors text-xs uppercase tracking-wider"
                >
                  Sign in{" "}
                  <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* OTP Verification Modal */}
      {showOtpFields && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"></div>
          <div className="bg-white w-full max-w-md mx-auto p-8 rounded-[2rem] shadow-2xl shadow-indigo-500/20 relative animate-fadeIn border border-slate-100">
            <button
              onClick={() => setShowOtpFields(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-400 hover:bg-red-50 hover:text-red-500 transition-colors"
              aria-label="Close OTP Modal"
            >
              <span className="text-xl leading-none font-bold">&times;</span>
            </button>
            <div className="flex flex-col items-center justify-center mb-6">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <h3 className="text-2xl font-[1000] text-slate-800 uppercase tracking-tight mb-1">
                Verify OTP
              </h3>
              <div className="text-[10px] uppercase tracking-widest font-black text-rose-500 bg-rose-50 px-3 py-1 rounded-full mt-2 border border-rose-100 shadow-sm">
                Time remaining: {formatTime(timer)}
              </div>
            </div>

            {successMessage && (
              <div className="mb-4 bg-emerald-50 border border-emerald-200 text-emerald-700 p-3 rounded-xl text-xs font-bold text-center">
                {successMessage}
              </div>
            )}

            <form onSubmit={handleOtpSubmit} className="space-y-5">
              <div className="space-y-1.5">
                <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest pl-1">Email OTP</label>
                <input
                  type="text"
                  id="otpEmail"
                  name="otpEmail"
                  maxLength={6}
                  value={otpData.otpEmail}
                  onChange={handleOtpChange}
                  className="block w-full px-4 py-3 bg-slate-50 border-2 border-slate-100 rounded-xl focus:bg-white focus:ring-4 focus:ring-indigo-50 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 tracking-[0.2em] text-center"
                  placeholder="------"
                />
                <p className="mt-1 text-[10px] font-bold text-slate-400 text-center">Check your email {formData.email}</p>
              </div>

              <div className="flex flex-col gap-3 mt-6 pt-2">
                <button
                  type="submit"
                  className="w-full flex justify-center py-3.5 px-4 rounded-xl shadow-lg shadow-emerald-200/50 text-sm font-black text-white bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 active:scale-[0.98] transition-all uppercase tracking-widest"
                >
                  Verify OTP
                </button>

                <button
                  type="button"
                  onClick={handleResendOTP}
                  disabled={!canResendOTP || isResending}
                  className={`w-full flex justify-center py-3.5 px-4 rounded-xl text-sm font-black transition-all uppercase tracking-widest ${canResendOTP && !isResending
                    ? "text-indigo-600 bg-indigo-50 hover:bg-indigo-100 active:scale-[0.98] border-2 border-indigo-100 hover:border-indigo-200"
                    : "text-slate-400 bg-slate-50 border-2 border-slate-100 cursor-not-allowed"
                    }`}
                >
                  {isResending ? "Resending..." : "Resend OTP"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {showToast && (
        <div className="fixed top-4 right-4 bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded shadow-md z-50">
          <div className="flex">
            <div className="py-1">
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-green-500 mr-2"
              />
            </div>
            <div>
              <p className="font-bold">Success</p>
              <p className="text-sm">{toastMessage}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PressRegister;